angular.module('impactx.passwordrecovery').controller('PasswordRecoveryDialogCtrl', [
    '$scope',
    'AppConfiguration',
    'passwordRecoveryData',
    'dataGen',
    'ToastService',
    '$redirect',
    'themeFactory',
    '$config',
    PasswordRecoveryDialogCtrl]);

function PasswordRecoveryDialogCtrl($scope, AppConfiguration, passwordRecoveryData, dataGen, ToastService, $redirect,
                                    themeFactory, $config) {
    $scope.logoUrl = AppConfiguration.get('loginPageLogoUrl');
    $scope.data = passwordRecoveryData;
    $scope.theme = themeFactory.getTheme();
    $scope.hasError = !!$scope.data.validationError;
    $scope.loginRoute =  $config.loginRoute;
    $scope.changePassword = function () {
        if (!$scope.hasError) {
            dataGen.postAsForm($scope, {passwordRecovery: $scope.data}, "/passwordrecovery/changepassword").then(function (data) {
                if (!data.error) {
                    $scope.dialogData.passwordRepeat.$setValidity("passwordChange", true);
                    ToastService.openStandardToast(data.successMessage);
                    $redirect.redirectTo(null, $scope.loginRoute);
                }
                else {
                    $scope.passwordChangeError = data.error;
                    $scope.dialogData.passwordRepeat.$setValidity("passwordChange", false);
                }
            });
        }
    }
}